import "./video.scss";

var videos = document.querySelectorAll(".videoBlock");

for (var i = 0; i < videos.length; i++) {
	let el = videos[i];
	let overlay = el.querySelector(".videoBlock__overlay");
	if (overlay) {
		let video_id = overlay.dataset.youtubeId;

		overlay.addEventListener("click", function (e) {
			e.preventDefault();
			el.innerHTML =
				'<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' +
				video_id +
				'?autoplay=1&mute=1" frameborder="0" allowfullscreen></iframe>';
			overlay.remove();
		});
	}
}
